<template>

  <div>

    <div style="background-color: #fff; padding-bottom: 30px">

      <mdb-container>

        <mdb-row>

          <div class="progress__container">

            <img :src="treeImg" style="width: 100%; height: auto" alt />

          </div>

        </mdb-row>

      </mdb-container>

    </div>

    <div style="background-color: #f7f7f7" class="mt-1 pt-1 cardClass">

      <mdb-container style="

              max-width: 97% !important;

              padding-bottom: 2rem;

              background-color: #fff;

              -webkit-box-shadow: 0px 6px 15px 0px rgba(0, 0, 0, 0.34);

              -moz-box-shadow: 0px 6px 15px 0px rgba(0, 0, 0, 0.34);

              box-shadow: 0px 6px 15px 0px rgba(0, 0, 0, 0.34);

            " class="mt-5">

        <mdb-row class="pt-5 pr-5">

          <mdb-col v-if="maritalStatus == 'MARRIED'" md="8" class="text-center">

            <span class="text-style">DATOS DE MI CONYUGE</span>

          </mdb-col>

          <mdb-col v-else md="8" class="text-center">

            <span class="text-style">01 CREAR SOLICITUD</span>

          </mdb-col>

          <mdb-col md="1" class="text-right" style="margin-left: 24%">

            <p style="

                    font-size: 30px;

                    cursor: pointer;

                    color: #e0e0e0;

                    font-weight: 700;

                  " @click="closeMessageError()">

              x

            </p>

          </mdb-col>

        </mdb-row>



        <mdb-col md="10" class="main-col">

          <div>

            <div>

              <mdb-row>

                <mdb-col md="0">

                  <div class="Rectangle-78"></div>

                </mdb-col>

                <mdb-col v-if="maritalStatus == 'MARRIED'" md="9" style="

                        text-align: justify;

                        font-family: Open Sans;

                        font-weight: 500;

                        color: #4f4f4f;

                      ">

                  <!-- <span class="text-style-2">Instrucciones:</span> -->

                  <p style="font-size: 18px">

                    1. Toma una fotografía de su rostro.

                  </p>

                  <p style="font-size: 18px">

                    2. Sube el archivo PDF de su CURP y el de su identificación

                    oficial INE o Pasaporte.

                  </p>



                  <p style="font-size: 18px">

                    3. Sube el archivo PDF de su acta de nacimiento.

                  </p>

                  <p style="font-size: 18px">

                    4. Ingresa sus datos laborales y recomendaciones de socios.

                  </p>

                  <p style="font-size: 18px">

                    5. Verifica tus datos y da click en “Enviar”.

                  </p>

                </mdb-col>

                <mdb-col v-else md="9" style="

                        text-align: justify;

                        font-family: Open Sans;

                        font-weight: 500;

                        color: #4f4f4f;

                      ">

                  <!-- <span class="text-style-2">Instrucciones:</span> -->

                  <p style="font-size: 18px">

                    1. Toma una fotografía de tu rostro.

                  </p>

                  <p style="font-size: 18px">2. Ingresa tu estado civil.</p>

                  <p style="font-size: 18px">

                    3. Sube el archivo PDF de tu CURP y de tu identificación

                    oficial INE o Pasaporte.

                  </p>



                  <p style="font-size: 18px">

                    4. Sube el archivo PDF de tu acta de nacimiento.

                  </p>

                  <p style="font-size: 18px">

                    5. Ingresa tus datos laborales y recomendaciones de socios.

                  </p>

                  <p style="font-size: 18px">

                    6. Verifica tus datos y da click en “Generar”.

                  </p>

                </mdb-col>

              </mdb-row>

              <mdb-row style="margin-top: 2%; width: 100%">

                <mdb-col md="3" style="text-align: right">

                  <div v-if="fileAvatar == ''" class="image-upload">

                    <label for="image-release">

                      <img @mouseup="mouseUpIcon('release')" @mousedown="mouseDownIcon('release')"

                        @mouseleave="mouseLeaveIcon('release')" @mouseover="mouseOverIcon('release')" @click="

                          $refs.camera.toggleModal();

                        $refs.webcam.start();

                                                                            " :src="'/img/icons/' + releaseIcon" class="icon" alt="agregar foto"

                        style="cursor: pointer" />

                    </label>

                    <!-- <input

                      type="file"

                      accept="image/jpg, image/png"

                      name="file"

                      id="image-release"

                      @change="uploadFile"

                    />-->

                  </div>

                  <div v-else class="image-upload input-group mb-5">

                    <img :src="fileAvatar" class="avatar-pic" alt="Profile Picture" />

                    <img :src="'/img/icons/editar-foto.svg'" class="edit-pic" alt="Profile Picture"

                      style="cursor: pointer" @click="

                        $refs.camera.toggleModal();

                      $refs.webcam.start();" />



                    <!-- <input

                      type="file"

                      accept="image/jpg, image/png"

                      name="file"

                      id="image-release"

                      @change="uploadFile"

                    />-->

                  </div>

                </mdb-col>

              </mdb-row>

              <mdb-row>

                <mdb-col md="12">

                  <div class="form__group">

                    <mdb-row v-if="maritalStatus == ''" style="margin-left: 3%">

                      <mdb-col md="12">

                        <div class="form__group">

                          <label class="form__label">Estado Civil</label>

                        </div>

                      </mdb-col>

                      <mdb-col md="2" style="margin-bottom: 10px">

                        <div class="form__group">

                          <div class="form__check">

                            <input type="radio" name="buyerType" id="casado" v-model="estadoCivil" value="MARRIED" />

                            <label for="casado">

                              <span :class="

                                estadoCivil == 'MARRIED'

                                  ? 'form__label-active'

                                  : ''

                              "></span>Casado

                            </label>

                          </div>

                        </div>

                      </mdb-col>

                      <mdb-col md="2" style="margin-bottom: 10px">

                        <div class="form__group">

                          <div class="form__check">

                            <input type="radio" name="buyerType" id="soltero" v-model="estadoCivil" value="SINGLE" />

                            <label for="soltero">

                              <span :class="

                                estadoCivil == 'SINGLE'

                                  ? 'form__label-active'

                                  : ''

                              "></span>Soltero

                            </label>

                          </div>

                        </div>

                      </mdb-col>

                      <mdb-col md="2" style="margin-bottom: 10px">

                        <div class="form__group">

                          <div class="form__check">

                            <input type="radio" name="buyerType" id="viudo" v-model="estadoCivil" value="WIDOWED" />

                            <label for="viudo">

                              <span :class="

                                estadoCivil == 'WIDOWED'

                                  ? 'form__label-active'

                                  : ''

                              "></span>Viudo

                            </label>

                          </div>

                        </div>

                      </mdb-col>

                      <mdb-col md="2" style="margin-bottom: 10px">

                        <div class="form__group">

                          <div class="form__check">

                            <input type="radio" name="buyerType" id="divorciado" v-model="estadoCivil" value="DIVORCED" />

                            <label for="divorciado">

                              <span :class="

                                estadoCivil == 'DIVORCED'

                                  ? 'form__label-active'

                                  : ''

                              "></span>Divorciado

                            </label>

                          </div>

                        </div>

                      </mdb-col>

                      <mdb-col v-show="false" md="2" style="margin-bottom: 10px">

                        <div class="form__group">

                          <div class="form__check">

                            <input type="radio" name="buyerType" id="separado" v-model="estadoCivil" value="SEPARATE" />

                            <label for="separado">

                              <span :class="

                                estadoCivil == 'SEPARATE'

                                  ? 'form__label-active'

                                  : ''

                              "></span>Separado

                            </label>

                          </div>

                        </div>

                      </mdb-col>

                    </mdb-row>

                  </div>

                </mdb-col>

              </mdb-row>

              <mdb-row class="mt-3" v-if="estadoCivil == 'DIVORCED'" style="margin-left: 3%">

                <!-- <mdb-col md="12">

                  <div class="form__group">

                    <label

                      class="form__label"

                      style="cursor: unset !important;"

                    >NOMBRE DE LA EX PAREJA</label>

                  </div>

                </mdb-col>-->

                <mdb-col md="12" style="margin-left: -5%">

                  <!-- <div style="border: 1px solid #3a8a65; border-radius: 5px; padding: 4rem;"> -->

                  <mdb-row style="margin-left: 3%">

                    <mdb-col md="10">

                      <label for="input_exname" class="form__label">Nombre ex espos@:</label>

                      <input type="text" id="input_exname" class="form__input" v-model="exCoupleName" />

                      <!-- <validation-error :validation="$v.exCoupleName"></validation-error> -->

                    </mdb-col>



                  </mdb-row>



                </mdb-col>

              </mdb-row>

              <mdb-row class="mt-5" style="margin-left: 3%">

                <mdb-col md="12">

                  <div class="form__group">

                    <label class="form__label" style="cursor: unset !important">IDENTIFICACIONES</label>

                  </div>

                </mdb-col>



                <mdb-col md="12" style="margin-left: -5%">

                  <div style="

                          border: 1px solid #3a8a65;

                          border-radius: 5px;

                          padding: 4rem;

                        ">

                    <label v-if="maritalStatus == ''" for="sectionData" class="form__label mb-3"

                      style="transform: translateY(3px)">Datos de contacto</label>

                    <mdb-row v-if="maritalStatus == ''" id="sectionData">

                      <!-- <mdb-col md="5">

                            <label for="input_email" class="form__label">Correo electrónico</label>

                            <input

                            type="text"

                            id="input_email"

                            class="form__input"

                            v-model="emailApplicant"

                          />

                          </mdb-col> -->

                      <mdb-col md="5">

                        <label for="input_phone" class="form__label">Teléfono de contacto:</label>

                        <input type="text" id="input_phone" class="form__input" v-model="phoneApplicant"

                          v-mask="'##########'" />

                        <validation-error :validation="$v.phoneApplicant"></validation-error>

                      </mdb-col>

                    </mdb-row>

                    <div class="form__group mt-5">

                      <div v-show="fileCurp == null" id="curpSection" class="form__group">



                        <mdb-row>

                          <mdb-col>

                            <label for="curpSection" class="form__label" style="cursor:auto;">Sube tu CURP

                              <small>(Actualizada, legible)</small>:

                              <br />

                              <span style="

                                        font-size: 12px;

                                        font-weight: 600;

                                        color: #000;

                                      ">

                                Puedes generarla aquí:

                                <a href="https://www.gob.mx/curp/" target="_blank">https://www.gob.mx/curp/</a>

                              </span>

                            </label>



                            <label for="curp-input" class="btn-label">

                              <img :src="'/img/icons/' + uploadIcon" style="width: 20px" />

                              SUBIR CURP

                            </label>

                            <input type="file" accept="application/pdf" name="file" id="curp-input"

                              style="visibility: hidden" @change="uploadCURP" />

                          </mdb-col>

                        </mdb-row>

                      </div>

                      <validation-error :validation="$v.fileCurp"></validation-error>

                      <div v-show="fileCurp != null" class="input-group">

                        <btn :text="'¡LISTO!'" :type="'primary-admin-success'" style="float: left"></btn>



                        <img style="margin-top: 10px; cursor: pointer" :src="'/img/icons/' + watchButton"

                          @click="viewPdf(fileCurp, 'CURP')" @mouseup="mouseUpIcon('watch')"

                          @mousedown="mouseDownIcon('watch')" @mouseleave="mouseLeaveIcon('watch')" />



                        <button type="button" class="btn btn-delete"

                          @click="removeCurp"

                          style="padding: 3px; position: inherit; top: 4px;">

                          <img :src="'/img/icons/InoBorrar.svg'" alt="icon eliminar" />

                        </button>

                      </div>

                    </div>

                    <!-- <mdb-row class="mt-3">

                      <mdb-col>

                        <label for="curpSection" class="form__label" style="cursor:auto;">Sube tu CURP

                          <small>(Actualizada, legible)</small>:

                          <br />

                          <span style="

                                    font-size: 12px;

                                    font-weight: 600;

                                    color: #000;

                                  ">

                            Puedes generarla aquí:

                            <a href="https://www.gob.mx/curp/" target="_blank">https://www.gob.mx/curp/</a>

                          </span>

                        </label>



                        <label for="curp-input" class="btn-label">

                          <img :src="'/img/icons/' + uploadIcon" style="width: 20px" />

                          SUBIR CURP

                        </label>

                        <input type="file" accept="application/pdf" name="file" id="curp-input"

                          style="visibility: hidden" @change="uploadCURP" />

                      </mdb-col>

                    </mdb-row> -->

                    <mdb-row class="mt-3">

                      <mdb-col md=8 sm=5>

                        <label for="input" class="form__label">Ingresa tu CURP:</label>

                        <input disabled="true" readOnly="true" type="text" v-model="curp" id="input" class="form__input disabled_color" style="

                                text-transform: uppercase;color:#828282;

                              " maxlength="18" placeholder="Ingresa tu CURP" required

                          pattern="[A-Z]{1}[AEIOUX]{1}[A-Z]{2}[0-9]{2}(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1])[HM]{1}(AS|BC|BS|CC|CS|CH|CL|CM|DF|DG|GT|GR|HG|JC|MC|MN|MS|NT|NL|OC|PL|QT|QR|SP|SL|SR|TC|TS|TL|VZ|YN|ZS|NE)[B-DF-HJ-NP-TV-Z]{3}[0-9A-Z]{1}[0-9]{1}" />

                        <validation-error :validation="$v.curp"></validation-error>

                        <span v-show="isCurpLoading" style="font-size: 15px;color: black;font-weight: revert;display: inline-block;" class="forgot-pwd-text mt-3 animated flash infinite">La CURP se está cargando. Por favor, espere hasta que el proceso finalice.</span>

                        <span v-if="isValidCurp === true" class="mt-3" style="display: inline-block;font-size: 15px;color: green;line-height: 15px;">CURP correcta. Por favor, verifica que la CURP corresponda al nombre de quien quedará como titular de la solicitud, sino es así puedes dar clic en el botón de eliminar para cargar la correspondiente.</span>

                        <span v-if="isValidCurp === false" class="mt-3" style="display: inline-block;font-size: 15px;color: red;line-height: 15px;">Error al detectar la CURP, intente de nuevo.</span>

                      </mdb-col>

                    </mdb-row>

                    <mdb-row class="mt-3">

                      <mdb-col md="6">

                        <label for="input_name" class="form__label">Nombre:</label>

                        <input :disabled="state !== 'EXTRANJERO'" :readOnly="state !== 'EXTRANJERO'" autocomplete="false" type="text" id="input_name" class="form__input disabled_color"

                          style="color:#828282;text-transform: uppercase;" v-model="name" />

                        <validation-error :validation="$v.name"></validation-error>

                      </mdb-col>

                    </mdb-row>

                    <mdb-row>

                      <mdb-col md="6">

                        <label for="input_last" class="form__label">Apellido Paterno:</label>

                        <input :disabled="state !== 'EXTRANJERO'" :readOnly="state !== 'EXTRANJERO'" type="text" id="input_last" class="form__input disabled_color" style="color:#828282;text-transform: uppercase;"

                          v-model="lastName" />

                        <validation-error :validation="$v.lastName"></validation-error>

                      </mdb-col>

                      <mdb-col md="6">

                        <label for="input_last2" class="form__label">Apellido Materno:</label>

                        <input :disabled="state !== 'EXTRANJERO'" :readOnly="state !== 'EXTRANJERO'" type="text" id="input_last2" class="form__input disabled_color" style="color:#828282;text-transform: uppercase;"

                          v-model="lastName2" />

                        <validation-error :validation="$v.lastName2"></validation-error>

                      </mdb-col>

                    </mdb-row>
                    <mdb-row v-if="state === 'EXTRANJERO'" class="mt-2">
                      <mdb-col md="2"></mdb-col>
                      <mdb-col md="8">
                        <small style="color: #e67e22;">Persona extranjera: verifique y corrija el nombre y apellidos si RENAPO los devuelve invertidos.</small>
                      </mdb-col>
                    </mdb-row>

                    <mdb-row class="mt-3">

                      <mdb-col md="4">

                        <label for="input_sex" class="form__label">Sexo:</label>

                        <!-- <input

                            type="text"

                            id="input_sex"

                            class="form__input"

                            style="width: 70%"

                            v-model="sexo"

                            :disabled="disabledCurp"

                          /> -->

                        <div class="form__group">

                          <select disabled="true" readOnly="true" name="sexo" v-model="sexo" id="input_sex" class="browser-default custom-select">>

                            <option value="HOMBRE">HOMBRE</option>

                            <option value="MUJER">MUJER</option>

                          </select>

                        </div>

                        <validation-error :validation="$v.sexo"></validation-error>

                      </mdb-col>

                    </mdb-row>

                    <mdb-row class="mt-3">

                      <mdb-col md="4">

                        <label for="input_date" class="form__label">Fecha de Nacimiento:</label>

                        <input disabled="true" type="text" id="input_date" class="split disabled_color" tabindex="1" maxlength="2" placeholder="DD"

                          v-mask="'##'" v-model="dia" readonly @click="$refs.filterDay.toggleModal()" />

                          <input disabled="true" type="text" id="input_date" class="split disabled_color" tabindex="2" maxlength="2" placeholder="MM"

                          v-mask="'##'" v-model="mes" readonly @click="$refs.filterDay.toggleModal()" />

                          <input disabled="true" type="text" id="input_date" class="split disabled_color" tabindex="3" maxlength="4" placeholder="AAAA"

                          v-mask="'####'" v-model="year" readonly @click="$refs.filterDay.toggleModal()" />

                        <validation-error :validation="$v.dia"></validation-error>

                        <validation-error :validation="$v.mes"></validation-error>

                        <validation-error :validation="$v.year"></validation-error>

                      </mdb-col>

                    </mdb-row>

                    <mdb-row class="mt-3 mb-5">

                      <mdb-col md="6">

                        <!-- <div class="form__group"> -->

                          <label for="input_entity" class="form__label">Entidad de Nacimiento:</label>



                          <input id="input_entity" disabled="true" type="text" class="form__input disabled_color" v-model="state" readonly style="color:#828282;text-transform: uppercase;"/>

                          <!-- <select disabled="true" readOnly="true" v-model="state" name="state" id="input_entity" class="browser-default custom-select">

                            <option v-for="(value, index) in locations" :key="index + '_state'">{{ value }}</option>

                          </select> -->

                        <!-- </div> -->

                        <!-- <input

                            type="text"

                            id="input_entity"

                            class="form__input"

                            v-model="state"

                            :disabled="disabledCurp"

                          /> --><validation-error :validation="$v.state"></validation-error>

                      </mdb-col>

                    </mdb-row>



                    <!-- <div class="form__group mt-5">

                      <div v-show="fileCurp == null" id="curpSection" class="form__group">



                        <mdb-row>

                          <mdb-col>

                            <label for="curpSection" class="form__label" style="cursor:auto;">Sube tu CURP

                              <small>(Actualizada, legible)</small>:

                              <br />

                              <span style="

                                        font-size: 12px;

                                        font-weight: 600;

                                        color: #000;

                                      ">

                                Puedes generarla aquí:

                                <a href="https://www.gob.mx/curp/" target="_blank">https://www.gob.mx/curp/</a>

                              </span>

                            </label>



                            <label for="curp-input" class="btn-label">

                              <img :src="'/img/icons/' + uploadIcon" style="width: 20px" />

                              SUBIR CURP

                            </label>

                            <input type="file" accept="application/pdf" name="file" id="curp-input"

                              style="visibility: hidden" @change="uploadCURP" />

                          </mdb-col>

                        </mdb-row>

                      </div>

                      <validation-error :validation="$v.fileCurp"></validation-error>

                      <div v-show="fileCurp != null" class="input-group">

                        <btn :text="'¡LISTO!'" :type="'primary-admin-success'" style="float: left"></btn>



                        <img style="margin-top: 10px; cursor: pointer" :src="'/img/icons/' + watchButton"

                          @click="viewPdf(fileCurp, 'CURP')" @mouseup="mouseUpIcon('watch')"

                          @mousedown="mouseDownIcon('watch')" @mouseleave="mouseLeaveIcon('watch')" />



                        <button type="button" class="btn btn-delete"

                          @click="fileCurp = null; cleanInputFile('curp-input');"

                          style="padding: 3px; position: inherit; top: 4px;">

                          <img :src="'/img/icons/InoBorrar.svg'" alt="icon eliminar" />

                        </button>

                      </div>

                    </div> -->

                    <div class="form__group mt-5">

                      <label for="idSection" class="form__label mb-3"

                        style="transform: translateY(3px); cursor:auto;">Sube tu Identificación <small>(Vigente, legible,

                          escaneada, ambos lados)</small>:</label>

                      <div v-show="fileIne == null" id="idSection" class="form__group">



                        <mdb-row>

                          <mdb-col md="5">

                            <label for="id-input" class="btn-label">

                              <img :src="'/img/icons/' + uploadIcon" style="width: 20px" /> SUBIR IDENTIFICACIÓN

                            </label>

                            <input type="file" accept="application/pdf" name="file" id="id-input"

                              style="visibility: hidden" @change="UploadIdentificacion" /></mdb-col>

                          <!-- <mdb-col>

                            <div

                              style="

                                font-size: 12px;

                                font-weight: 600;

                                color: #000;

                              "

                            >

                              La identificación debe estar vigente

                            </div>

                          </mdb-col> -->

                        </mdb-row>

                      </div>

                      <validation-error :validation="$v.fileIne"></validation-error>

                      <div v-show="fileIne != null" class="input-group">

                        <btn :text="'¡LISTO!'" :type="'primary-admin-success'" style="float: left"></btn>



                        <img style="margin-top: 10px; cursor: pointer" :src="'/img/icons/' + watchButton"

                          @click="viewPdf(fileIne, 'Identificación')" @mouseup="mouseUpIcon('watch')"

                          @mousedown="mouseDownIcon('watch')" @mouseleave="mouseLeaveIcon('watch')" />

                        <button type="button" class="btn btn-delete" @click="fileIne = null; cleanInputFile('id-input');"

                          style="padding: 3px; position: inherit; top: 4px;">

                          <img :src="'/img/icons/InoBorrar.svg'" alt="icon eliminar" />

                        </button>

                      </div>

                    </div>



                    <div class="form__group mt-5">

                      <label for="actaSection" class="form__label mb-3"

                        style="transform: translateY(3px); cursor:auto;">Sube tu Acta de Nacimiento <small>(Actualizada,

                          escaneada, legible)</small>:</label>

                      <div v-show="actaUrl == null" id="actaSection" class="form__group">



                        <mdb-row>

                          <mdb-col md="5">

                            <label for="acta-input" class="btn-label">

                              <img :src="'/img/icons/' + uploadIcon" style="width: 20px" /> SUBIR ACTA

                            </label>

                            <input type="file" accept="application/pdf" name="file" id="acta-input"

                              style="visibility: hidden" @change="uploadActa" />

                          </mdb-col>

                          <!-- <mdb-col>

                            <div

                              style="

                                font-size: 12px;

                                font-weight: 600;

                                color: #000;

                              "

                            >

                              El acta de nacimiento debe estar actualizada.

                            </div>

                          </mdb-col> -->

                        </mdb-row>

                      </div>

                      <validation-error :validation="$v.actaUrl"></validation-error>

                      <div v-show="actaUrl != null" class="input-group">

                        <btn :text="'¡LISTO!'" :type="'primary-admin-success'" style="float: left"></btn>



                        <img style="margin-top: 10px; cursor: pointer" :src="'/img/icons/' + watchButton"

                          @click="viewPdf(actaUrl, 'Acta de nacimiento')" @mouseup="mouseUpIcon('watch')"

                          @mousedown="mouseDownIcon('watch')" @mouseleave="mouseLeaveIcon('watch')" />

                        <button type="button" class="btn btn-delete"

                          @click="actaUrl = null; cleanInputFile('acta-input');"

                          style="padding: 3px; position: inherit; top: 4px;">

                          <img :src="'/img/icons/InoBorrar.svg'" alt="icon eliminar" />

                        </button>

                      </div>

                    </div>



                    <!-- <div class="invalid-feedback">

                      <HelperMessage type="error" text="Tu CURP es invalido" />

                    </div>

                    <div v-show="CURPimageError">

                      <HelperMessage type="error" text="Sube tu CURP" />

                    </div>

                    <div v-if="imageError">

                      <HelperMessage type="error" text="Sube una foto" />

                    </div>

                    <div v-if="IneImageError">

                      <HelperMessage type="error" text="Sube una identificación oficial" />

                    </div> -->

                    <div>



                    </div>

                  </div>

                </mdb-col>

                <mdb-col md="12"></mdb-col>

              </mdb-row>

              <!-- <mdb-row  v-show="step2" class="mr-5 mt-5" style="margin-left: 0%;">

                <mdb-col md="12">

                  <div class="form__group">

                    <label class="form__label">DATOS PERSONALES</label>

                  </div>

                </mdb-col>

                <div style="border: 1px solid #3a8a65; border-radius: 5px;">

                  <div style="padding-left: 20px; padding-right: 20px;">

                    <mdb-col md="12">



                    </mdb-col>

                  </div>

                </div>

              </mdb-row>-->



              <mdb-row class="mt-5" style="margin-left: 3%">

                <mdb-col md="12">

                  <div class="form__group">

                    <label class="form__label" style="cursor: unset !important">

                      DATOS LABORALES

                      <!-- <img src="/img/icons/alert.svg" alt="Opcional" />

                      <span

                        class="ml-2"

                        style="font-family: Open Sans; font-size: 12px; font-weight: normal; letter-spacing: normal; color: #dc7134;"

                      >Opcional</span>-->

                    </label>

                  </div>

                </mdb-col>

                <mdb-col md="12" style="margin-left: -5%">

                  <div style="

                          border: 1px solid #3a8a65;

                          border-radius: 5px;

                          padding: 4rem;

                        ">

                    <mdb-row class="mb-5">

                      <mdb-col md="6">

                        <label v-if="maritalStatus == ''" class="form__label">¿Laboras actualmente?</label>

                        <label v-else class="form__label">¿Labora actualmente?</label>

                        <div class="form__check">

                          <input type="radio" id="laboraSi" v-model="work" :value="true" />

                          <label for="laboraSi">

                            <span :class="work ? 'form__label-active' : ''"></span>

                            Si

                          </label>

                        </div>

                        <div class="form__check">

                          <input type="radio" id="laboraNo" v-model="work" :value="false" />

                          <label for="laboraNo">

                            <span :class="!work ? 'form__label-active' : ''"></span>

                            No

                          </label>

                        </div>

                      </mdb-col>



                    </mdb-row>

                    <div v-if="work">

                      <mdb-row>

                        <mdb-col md="6">

                          <label for="input_company_name" class="form__label">Nombre de la empresa:</label>

                          <input type="text" id="input_company_name" class="form__input" v-model="nameCompany" />

                          <validation-error :validation="$v.nameCompany"></validation-error>

                        </mdb-col>

                        <mdb-col md="6">

                          <label for="input_profesion" class="form__label">Profesión:</label>

                          <input type="text" maxlength="100" id="input_profesion" class="form__input"

                            v-model="profession" />



                          <validation-error :validation="$v.profession"></validation-error>



                        </mdb-col>

                      </mdb-row>

                      <mdb-row class="mt-4">

                        <mdb-col md="6">

                          <label for="input_puesto" class="form__label">Puesto:</label>

                          <input type="text" maxlength="100" id="input_puesto" class="form__input"

                            v-model="currentPosition" />

                          <validation-error :validation="$v.currentPosition"></validation-error>

                        </mdb-col>

                        <mdb-col md="6">

                          <label for="input_giro" class="form__label">Giro de la empresa:</label>

                          <input type="text" maxlength="100" id="input_giro" class="form__input"

                            v-model="businessActivity" />

                          <validation-error :validation="$v.currentPosition"></validation-error>



                        </mdb-col>

                      </mdb-row>

                      <mdb-row class="mt-4">

                        <mdb-col md="12">

                          <label for="input_direccion" class="form__label">Dirección de la empresa:</label>

                          <input type="text" maxlength="300" id="input_direccion" class="form__input"

                            v-model="addressCompany" />



                          <validation-error :validation="$v.addressCompany"></validation-error>

                        </mdb-col>



                      </mdb-row>

                      <mdb-row class="mt-4">

                        <mdb-col md="6">

                          <label for="input_phone_company" class="form__label">Teléfono de la empresa:</label>

                          <input type="text" id="input_phone_company" class="form__input" v-model="phoneCompany"

                            v-mask="'##########'" />



                          <validation-error :validation="$v.phoneCompany"></validation-error>

                        </mdb-col>

                        <mdb-col md="6"> </mdb-col>

                      </mdb-row>

                    </div>

                    <div v-else>

                      <mdb-row>

                        <mdb-col md="12">

                          <label v-if="maritalStatus == ''" for="text_description" class="form__label">¿A qué te

                            dedicas?</label>

                          <label v-else for="text_description" class="form__label">¿A qué se dedica?</label>

                          <textarea id="text_description" v-model="activityDescription" class="form-control" rows="8"

                            cols="500" maxlength="1000"

                            :placeholder="maritalStatus == '' ? 'Describe a qué te dedicas' : 'Describe a qué se dedica'"

                            style="font-size: 15px; font-weight: 600; color: #000;width: 100%; box-sizing: border-box;">

                            </textarea>

                          <span style="font-size: 14px; ">{{ activityDescription.length + " / 1000" }}</span>



                          <validation-error :validation="$v.activity"></validation-error>

                        </mdb-col>

                      </mdb-row>

                    </div>

                    <mdb-row class="mt-4">

                      <mdb-col md="12">

                        <label for="buttonUpload" class="form__label" style="cursor:auto;">Subir constancia de situación

                          fiscal a tu nombre:<br />

                          <small>Con tus datos, no de la empresa donde laboras. Asegúrate de subir todas las hojas de tu

                            constancia.</small>

                        </label>

                        <div v-show="pdfUrl == null" class="curp-upload">

                          <label for="worker-input" class="btn-label">

                            <img :src="'/img/icons/' + uploadIcon" style="width: 20px" />

                            SUBIR CONSTANCIA

                          </label>

                          <input type="file" accept="application/pdf" name="file" id="worker-input"

                            @change="uploadWorker" />

                          <validation-error :validation="$v.worker"></validation-error>

                        </div>

                        <div v-show="pdfUrl != null" class="input-group">

                          <btn :text="'¡LISTO!'" :type="'primary-admin-success'" style="float: left"></btn>



                          <img style="margin-top: 10px; cursor: pointer" :src="'/img/icons/' + watchButton" @click="

                            viewPdf(pdfUrl, 'Constancia de situación fiscal')

                          " @mouseup="mouseUpIcon('watch')" @mousedown="mouseDownIcon('watch')"

                            @mouseleave="mouseLeaveIcon('watch')" />

                          <button type="button" class="btn btn-delete"

                            @click="pdfUrl = null; cleanInputFile('worker-input');"

                            style="padding: 3px; position: inherit; top: 4px;">

                            <img :src="'/img/icons/InoBorrar.svg'" alt="icon eliminar" />

                          </button>

                        </div>

                      </mdb-col>

                    </mdb-row>

                  </div>

                </mdb-col>

              </mdb-row>

              <mdb-row v-if="maritalStatus == ''" class="mt-5" style="margin-left: 3%">

                <mdb-col md="12">

                  <div class="form__group">

                    <label class="form__label" style="cursor: unset !important">

                      Agrega {{ numberR }} recomendación(es) de socio(s) |

                      <b>Solo se permiten propietarios titulares</b>

                    </label>

                  </div>

                </mdb-col>

                <mdb-col md="12" style="margin-left: -5%">

                  <div style="

                          border: 1px solid #3a8a65;

                          border-radius: 5px;

                          padding: 4rem;

                          padding-top: 15px;

                        ">

                    <mdb-row>

                      <mdb-col md="12">

                        <div class="form__group">

                          <label class="form__label"

                            style="cursor:auto; font-size:13px; text-align:justify; margin-bottom:10px;">

                            <b>Los datos deben corresponder al/los socio(s) que te recomienda(n), no coloques tus datos de

                              contacto</b>,

                            ya que se te regresará la solicitud para corregirla. <b>Recuerda, debe ser un socio

                              titular</b>, si el socio no responde, se te notificará para que actualices los datos.

                          </label>

                        </div>

                      </mdb-col>

                      <mdb-col md="12">

                        <mdb-row>

                          <mdb-col md="6">

                            <div class="form__group">

                              <label class="form__label" for="singleRe_name">Nombre(s):</label>

                              <input :disabled="recomendations.length == numberR" type="text" class="form__input"

                                id="singleRe_name" v-model="singleRe.firstName" />

                              <validation-error :validation="$v.singleRe.firstName"></validation-error>

                            </div>

                          </mdb-col>

                        </mdb-row>

                        <mdb-row>

                          <mdb-col md="6">

                            <div class="form__group">

                              <label class="form__label" for="singleRe_last">Apellido paterno:</label>

                              <input :disabled="recomendations.length == numberR" type="text" class="form__input"

                                id="singleRe_last" v-model="singleRe.lastName" />

                              <validation-error :validation="$v.singleRe.lastName"></validation-error>

                            </div>

                          </mdb-col>

                          <mdb-col md="6">

                            <div class="form__group">

                              <label class="form__label" for="singleRe_last2">Apellido materno:</label>

                              <input id="singleRe_last2" type="text" class="form__input" v-model="singleRe.motherLastName"

                                :disabled="recomendations.length == numberR" />

                              <validation-error :validation="$v.singleRe.motherLastName"></validation-error>

                            </div>

                          </mdb-col>

                        </mdb-row>

                        <mdb-row>

                          <mdb-col lg="3" md="4" sm="6" xs="6">

                            <div class="form__group">

                              <label class="form__label" for="singleRe_accion">No. de la acción:</label>

                              <input :disabled="recomendations.length == numberR" type="text" class="form__input"

                                v-model="singleRe.accion" v-mask="'#####'" id="singleRe_accion" />

                            </div>

                          </mdb-col>

                        </mdb-row>

                        <mdb-row>

                          <mdb-col lg="6" md="6" sm="6" xs="6">

                            <div class="form__group">

                              <label class="form__label" for="singleRe_email">Correo electrónico:</label>

                              <input :disabled="recomendations.length == numberR" type="text" class="form__input"

                                id="singleRe_email" v-model="singleRe.email" />

                              <validation-error :validation="$v.singleRe.email"></validation-error>

                            </div>

                          </mdb-col>

                        </mdb-row>

                        <mdb-row>

                          <mdb-col lg="6" md="6" sm="6" xs="6">

                            <div class="form__group">

                              <label class="form__label">Teléfono celular:</label>

                              <input :disabled="recomendations.length == numberR" type="text" class="form__input"

                                v-model="singleRe.phone" v-mask="'##########'" />

                              <validation-error :validation="$v.singleRe.phone" type="maxLength"

                                message="introduce solamente los 10 numeros de teléfono"></validation-error>

                            </div>

                          </mdb-col>

                        </mdb-row>

                        <mdb-row>

                          <mdb-col>

                            <btn v-if="recomendations.length == numberR" type="disabled" text="AGREGAR RECOMENDACIÓN"

                              class="mt-5" />

                            <btn v-else type="primary-admin" text="AGREGAR RECOMENDACIÓN" @onClick="addRecomendation"

                              class="mb-5" />

                          </mdb-col>

                        </mdb-row>

                      </mdb-col>

                    </mdb-row>

                    <mdb-row class="mt-3">

                      <label class="form__label">Recomendaciones registradas</label>

                      <HelperMessage v-if="recomendations.length < numberR" type="error"

                        :text="'Ingresa ' + numberR + ' recomendaciones'" />

                      <table class="table table-striped" style="border: solid 2px #bdbdbd">

                        <tr>

                          <th>Nombre</th>

                          <!-- <th class="text-center">Editar</th> -->

                          <th class="text-center">Eliminar</th>

                        </tr>

                        <tr v-for="(item, index) in displayedPost" v-bind:key="index">

                          <td>

                            {{

                              item.firstName +

                              " " +

                              item.lastName +

                              " " +

                              item.motherLastName

                            }}

                          </td>

                          <!-- <td class="text-center">

                            <button type="button" class="btn btn-edit" @click="editRecomend(index)">

                              <img :src="'/img/icons/InoEditarr.svg'" alt="icon editar" />

                            </button>

                          </td>-->

                          <td class="text-center">

                            <button type="button" class="btn btn-delete" @click="

                              indexDelete = index;

                            $refs.deleteClub.toggleModal();

                                                                                          ">

                              <img :src="'/img/icons/InoBorrar.svg'" alt="icon borrar" />

                            </button>

                          </td>

                        </tr>

                      </table>

                    </mdb-row>

                  </div>

                </mdb-col>

              </mdb-row>



              <mdb-row class="mt-5 mb-5">

                <mdb-col class="text-right">

                  <div class="btn-submit-docs">

                    <!-- <div v-if="!step2">

                       <btn

                          style="display: inline; padding-right: 1rem;"

                        :text="'CANCELAR'"

                        :type="'ghost'"

                        @onClick="closeMessageError()"

                      />

                        <btn  style="display: inline;" :text="'GENERAR'" :type="'disabled'"/>

                    </div> -->

                    <div>

                      <btn style="display: inline; padding-right: 1rem;" :text="'CANCELAR'" :type="'ghost'"

                        @onClick="closeMessageError()" />

                      <btn v-if="

                        fileAvatar != '' &&

                        name != '' &&

                        lastName != '' &&

                        lastName2 != '' &&

                        sexo != '' &&

                        dia != '' &&

                        mes != '' &&

                        year != '' &&

                        state != '' &&

                        curpOK &&

                        (phoneApplicant != '' || maritalStatus == 'MARRIED') &&

                        (recomendations.length == numberR ||

                          maritalStatus == 'MARRIED') &&

                        ((nameCompany != '' &&

                          phoneCompany != '' &&

                          profession != '' &&

                          businessActivity != '' &&

                          pdfUrl != null &&

                          addressCompany != '' &&

                          currentPosition != '' && work) || (!work && activityDescription != '')) &&

                        fileCurp != null &&

                        actaUrl != null &&

                        fileIne != null" style="display: inline;" :text="'GENERAR'" :type="'primary-block'"

                        @onClick="confirmCurp" />

                      <btn v-else style="display: inline;" :text="'GENERAR'" :type="'disabled'" />



                    </div>



                  </div>

                </mdb-col>

              </mdb-row>

            </div>

            <!---FLAG-->

          </div>

        </mdb-col>

      </mdb-container>

    </div>



    <Loader v-show="isLoading" />

    <Popup ref="camera" size="md">

      <div class="text-center">

        <mdb-row>

          <mdb-col md="6">

            <mdb-row>

              <h2>Cámara</h2>

              <div class="border">

                <vue-web-cam ref="webcam" :device-id="deviceId" width="100%" height="100%" @started="onStarted"

                  @stopped="onStopped" @error="onError" @cameras="onCameras" @camera-change="onCameraChange" />

              </div>

            </mdb-row>

            <mdb-row>

              <div class="col-md-12">

                <select v-model="camera">

                  <option>-- Selecciona cámara --</option>

                  <option v-for="device in devices" :key="device.deviceId" :value="device.deviceId">

                    {{ device.label }}

                  </option>

                </select>

              </div>

              <div class="col-md-12">

                <button type="button" class="btn btn-primary" @click="onCapture">

                  Tomar foto

                </button>

              </div>

            </mdb-row>

          </mdb-col>

          <mdb-col v-if="imgSrc" md="6">

            <mdb-row>

              <h2>Foto Capturada</h2>

              <vue-cropper ref="cropper" :aspect-ratio="9 / 9" :src="imgSrc" preview=".preview" />

            </mdb-row>

            <mdb-row>

              <div class="col-md-12">

                <button type="button" class="btn btn-primary" @click="cropImage">

                  Recortar

                </button>

              </div>

            </mdb-row>

          </mdb-col>

          <mdb-col v-if="imgSrc" md="12">

            <mdb-row>

              <div class="col-md-12">

                <h2>Vista Previa</h2>

                <div class="image-upload">

                  <label for="image-release">

                    <img :src="imgSrc" class="avatar-pic" alt="Profile Picture" style="cursor: pointer" />

                  </label>

                </div>

              </div>

            </mdb-row>

            <mdb-row>

              <div class="col-md-12">

                <button type="button" class="btn btn-primary" @click="

                  $refs.camera.toggleModal();

                $refs.webcam.stop();

                                                      ">

                  Finalizar edición

                </button>

              </div>

            </mdb-row>

          </mdb-col>

        </mdb-row>

      </div>

    </Popup>

    <Popup size="lg" ref="confirm" :title="titleModal">

      <div class="embed-responsive embed-responsive-16by9 z-depth-1-half" style="height: 75vh">

        <iframe title="titulo" class="embed-responsive-item" :src="popUrl" allowfullscreen></iframe>

      </div>

      <div class="accordion__button">

        <btn style="float: left" text="CERRAR" @onClick="$refs.confirm.toggleModal()" type="primary-block" />

      </div>

    </Popup>

    <Popup size="sm" title header ref="deleteClub">

      <div class="text-left">

        <mdb-row>

          <mdb-col>

            <mdb-row>

              <div style="

                      font-family: Josefin Sans;

                      font-size: 22px;

                      font-weight: 600;

                      font-stretch: normal;

                      font-style: normal;

                      line-height: normal;

                      letter-spacing: normal;

                      color: #dc7134; ;

                    ">

                ¿ELIMINAR RECOMENDACIÓN?

              </div>

            </mdb-row>

            <mdb-row class="mt-5">

              <div style="

                      font-family: Open Sans;

                      font-size: 16px;

                      font-weight: normal;

                      font-stretch: normal;

                      font-style: normal;

                      line-height: normal;

                      letter-spacing: normal;

                      color: #4f4f4f;

                    ">

                Este registro será elimanado y tendrás que volver a introducir

                uno nuevo.

              </div>

            </mdb-row>

            <mdb-row style="margin-top: 5rem">

              <div class="divLine"></div>

            </mdb-row>

            <mdb-row class="mt-3">

              <div style="margin-left: 20%">

                <btn @onClick="deleteRecomendation" :text="'Eliminar'" :type="'primary-admin'" style="float: right"></btn>

                <btn @onClick="$refs.deleteClub.toggleModal()" :text="'Cancelar'" :type="'primary-admin-ghost'"

                  style="float: right; margin-right: 1rem"></btn>

              </div>

            </mdb-row>

          </mdb-col>

        </mdb-row>

      </div>

    </Popup>

    <Popup title="Selecciona tu fecha de nacimiento" size="sm" ref="filterDay">

      <mdb-container class="mt-4">

        <mdb-row>

          <mdb-col col="12" class="d-flex justify-content-center align-items-center">

            <datepicker :inline=true minimum-view="day" :language="languageDatePicker" v-model="datePickerValue"

              calendar-class="datepicker"></datepicker>

          </mdb-col>

        </mdb-row>

        <mdb-row class="mt-3">

          <mdb-col class="d-flex justify-content-center align-items-center">

            <btn @onClick="$refs.filterDay.toggleModal()" :text="'Cancelar'" :type="'primary-admin-ghost'" class="mr-4">

            </btn>

            <btn @onClick="setFilterDay" :text="'Aceptar'" :type="'primary-admin'"></btn>

          </mdb-col>

        </mdb-row>

      </mdb-container>

    </Popup>

  </div>

</template>





<script>

import { mdbContainer, mdbRow, mdbCol, mdbCard, mdbCardImage } from "mdbvue";

import btn from "../../components/core/Button";

import HelperMessage from "../core/HelperMessage";

import Axios from "axios";

import Swal from "sweetalert2";

import { mapGetters, mapActions } from "vuex";

import Datepicker from 'vuejs-datepicker';

import moment from 'moment';

import { es } from 'vuejs-datepicker/dist/locale'

import Loader from "../../components/core/Loader";

import { WebCam } from "vue-web-cam";

import Popup from "../core/Popup";

import VueCropper from "vue-cropperjs";

import "cropperjs/dist/cropper.css";

import {

  required,

  requiredIf,

  email,

  numeric,

  minLength,

  maxLength,

} from "vuelidate/lib/validators";

import ValidationError from "./misc/ValidationError";

import { mask } from "vue-the-mask";



export default {

  name: "Curp",

  components: {

    mdbContainer,

    mdbRow,

    mdbCol,

    mdbCard,

    mdbCardImage,

    btn,

    HelperMessage,

    Loader,

    "vue-web-cam": WebCam,

    VueCropper,

    Popup,

    ValidationError,

    Datepicker

  },

  directives: { mask },

  data() {

    return {

      isValidCurp: undefined,

      isCurpLoading: false,

      languageDatePicker: es,

      datePickerValue: new Date(),

      imgSrc: null,

      camera: null,

      deviceId: null,

      devices: [],

      curp: "",

      fileAvatar: "",

      fileCurp: "",

      fileIne: "",

      estadoCivil: "MARRIED",

      uploadIcon: "upload-document.svg",

      releaseIcon: "release-default.svg",

      approvedIcon: "approved-2.svg",

      watchButton: "watch-unpressed-btn.svg",

      iconEdit: "editar-default.svg",

      iconDelete: "borrar-default.svg",

      showCard: false,

      filesCurp: null,

      filesIne: null,

      filesProfile: null,

      imageError: false,

      CURPimageError: false,

      IneImageError: false,

      candidates: [],

      isLoading: false,

      isCorrect: true,

      isInCorrect: false,

      urlAvatar: "",

      sexo: "",

      dia: "",

      mes: "",

      year: "",

      name: "",

      lastName: "",

      lastName2: "",

      state: "",

      step2: false,

      curpOK: false,

      ineOK: false,

      documentType: "",

      extension: "",

      extensionIne: "",

      messageIne: "",

      documentValue: "",

      popUrl: null,

      ////////

      pdfUrl: null,

      filesPDF: null,

      recomendations: [],

      singleRe: {

        firstName: "",

        lastName: "",

        motherLastName: "",

        accion: "",

        email: "",

        phone: "",

      },

      nameCompany: "",

      phoneCompany: "",

      currentPosition: "",

      indexDelete: 0,

      ////////////////

      exCoupleName: "",

      exCoupleLastName: "",

      exCoupleMotherLastName: "",

      actaUrl: null,

      actaPDF: null,

      titleModal: "",

      fileCurp: null,

      fileIne: null,

      numberR: 0,

      work: true,

      phoneApplicant: "",

      emailApplicant: "",

      profession: "",

      addressCompany: "",

      businessActivity: "",

      activityDescription: "",

      disabledCurp: true,

      locations: [

        "AGUASCALIENTES",

        "BAJA CALIFORNIA",

        "BAJA CALIFORNIA SUR",

        "CAMPECHE",

        "COAHUILA",

        "COLIMA",

        "CHIAPAS",

        "CHIHUAHUA",

        "DISTRITO FEDERAL",

        "DURANGO",

        "GUANAJUATO",

        "GUERRERO",

        "HIDALGO",

        "JALISCO",

        "MÉXICO",

        "MICHOACÁN",

        "MORELOS",

        "NAYARIT",

        "NUEVO LEÓN",

        "OAXACA",

        "PUEBLA",

        "QUERÉTARO",

        "QUINTANA ROO",

        "SAN LUIS POTOSÍ",

        "SINALOA",

        "SONORA",

        "TABASCO",

        "TAMAULIPAS",

        "TLAXCALA",

        "VERACRUZ",

        "YUCATÁN",

        "ZACATECAS",

      ]

    };

  },

  validations: {

    curp: { required },

    name: { required },

    lastName: { required },

    lastName2: { required },

    dia: { required },

    mes: { required },

    year: { required },

    sexo: { required },

    state: { required },

    fileCurp: {

      required: requiredIf(function () {

        if (this.fileCurp != null) {

          return false;

        } else {

          return true;

        }

      }),

    },

    fileIne: {

      required: requiredIf(function () {

        if (this.fileIne != null) {

          return false;

        } else {

          return true;

        }

      }),

    },

    // exCoupleName: {

    //   required: requiredIf(function() {

    //     if( this.estadoCivil == "DIVORCED"){

    //       return true;

    //     }

    //     else{

    //       return false

    //     }

    //   })

    // },

    actaUrl: {

      required: requiredIf(function () {

        if (this.actaUrl != null) {

          return false;

        } else {

          return true;

        }

      }),

    },

    nameCompany: {

      required: requiredIf(function () {

        if (this.nameCompany != "") {

          return false;

        } else {

          return true;

        }

      }),

      // required: requiredIf(function(){

      // if(this.nameCompany == "" && this.phoneCompany == '' && this.currentPosition == '' && this.pdfUrl == null )

      //     return false;

      // else{

      //     if( this.nameCompany != ""){

      //       return false;

      //     }

      //     else{

      //       return true;

      //     }

      //   }

      // }),

    },

    phoneCompany: {

      minLength: minLength(10),

      required: requiredIf(function () {

        if (this.phoneCompany != "" && this.work) {

          return false;

        } else {

          return true;

        }

      }),

    },

    currentPosition: {

      required: requiredIf(function () {

        if (this.currentPosition != "" && this.work) {

          return false;

        } else {

          return true;

        }

      }),

    },

    profession: {

      required: requiredIf(function () {

        if (this.profession != "" && this.work) {

          return false;

        } else {

          return true;

        }

      }),

    },

    addressCompany: {

      required: requiredIf(function () {

        if (this.addressCompany != "" && this.work) {

          return false;

        } else {

          return true;

        }

      }),

    },

    businessActivity: {

      required: requiredIf(function () {

        if (this.addressCompany != "" && this.work) {

          return false;

        } else {

          return true;

        }

      }),

    },

    worker: {

      required: requiredIf(function () {

        if (this.pdfUrl != null && this.work) {

          return false;

        } else {

          return true;

        }

      }),

    },

    activity: {

      required: requiredIf(function () {

        if (this.activityDescription != "" && !this.work) {

          return false;

        } else {

          return true;

        }

      }),



    },

    phoneApplicant: {

      required: requiredIf(function () {

        if (this.phoneApplicant != "") {

          return false;

        } else {

          return true;

        }

      }),



    },

    singleRe: {

      firstName: {

        required: requiredIf(function () {

          return this.recomendations.length < this.numberR;

        }),

      },

      lastName: {

        required: requiredIf(function () {

          return this.recomendations.length < this.numberR;

        }),

      },

      motherLastName: {

        required: requiredIf(function () {

          return this.recomendations.length < this.numberR;

        }),

      },

      email: {

        required: requiredIf(function () {

          return this.recomendations.length < this.numberR;

        }),

        email,

      },

      phone: {

        required: requiredIf(function () {

          return this.recomendations.length < this.numberR;

        }),

        numeric,

        maxLength: maxLength(10),

      },

    },

  },

  methods: {

    ...mapActions([

      "getCurpInfo",

      "completeStep1",

      "postDataSpouse",

      "sendInvestigation",

      "recommendationsNumber",

    ]),

    cleanInputFile(id) {

      document.getElementById(id).value = '';

    },

    async recommendatiosN() {

      let response = await this.recommendationsNumber();



      this.numberR = response.data.data;

    },

    viewPdf(url, title) {

      this.popUrl = url;

      this.titleModal = title;

      this.$refs.confirm.toggleModal();

    },

    uploadWorker: function (evt) {

      this.pdfUrl = URL.createObjectURL(evt.target.files[0]);

      let aux = this;

      var rdr = new FileReader();

      rdr.onload = function (e) {

        aux.filesPDF = e.target.result.split(",")[1];

      };

      rdr.readAsDataURL(evt.target.files[0]);

    },

    checkForm(form) {

      return (

        Object.keys(form).length ===

        Object.keys(form).filter((key) => form[key].length > 0).length

      );

    },

    addRecomendation() {



      this.$v.singleRe.$touch();

      if (

        this.recomendations.length < this.numberR &&

        !this.$v.singleRe.$invalid

      ) {

        this.$v.singleRe.$reset();

        this.recomendations.push(this.singleRe);

        this.singleRe = {

          firstName: "",

          lastName: "",

          motherLastName: "",

          accion: "",

          email: "",

          phone: "",

        };

      }

    },

    deleteRecomendation() {

      //console.log(this.indexDelete);

      this.recomendations.splice(this.indexDelete, 1);

      this.$refs.deleteClub.toggleModal();

    },

    cropImage() {

      // get image data for post processing, e.g. upload or setting image src

      this.imgSrc = this.$refs.cropper.getCroppedCanvas().toDataURL();

      this.fileAvatar = this.imgSrc;

      //console.log(this.fileAvatar)

    },

    reset() {

      this.fileAvatar = "";

      this.$refs.cropper.reset();

    },

    zoom(percent) {

      this.$refs.cropper.relativeZoom(percent);

    },

    move(offsetX, offsetY) {

      this.$refs.cropper.move(offsetX, offsetY);

    },

    mouseOverIcon(module) {

      if (module == "upload") {

        let uploadIcon = this.uploadIcon.split("-");

        this.uploadIcon = `${uploadIcon[0]}-document.svg`;

      } else if (module == "release") {

        let releaseIcon = this.releaseIcon.split("-");

        this.releaseIcon = `${releaseIcon[0]}-hover.svg`;

      } else {

        let helpIcon = this.helpIcon.split("-");

        this.helpIcon = `${helpIcon[0]}-hover.svg`;

        this.showCard = true;

      }

    },

    mouseLeaveIcon(module) {

      if (module == "upload") {

        let uploadIcon = this.uploadIcon.split("-");

        this.uploadIcon = `${uploadIcon[0]}-document.svg`;

      } else if (module == "release") {

        let releaseIcon = this.releaseIcon.split("-");

        this.releaseIcon = `${releaseIcon[0]}-default.svg`;

      } else if (module == "watch") {

        this.watchButton = "watch-unpressed-btn.svg";

      } else {

        let helpIcon = this.helpIcon.split("-");

        this.helpIcon = `${helpIcon[0]}-default.svg`;

        this.showCard = false;

      }

    },

    mouseDownIcon(module) {

      if (module == "upload") {

        let uploadIcon = this.uploadIcon.split("-");

        this.uploadIcon = `${uploadIcon[0]}-document.svg`;

      } else if (module == "watch") {

        this.watchButton = "watch-pressed-btn.svg";

      } else {

        let releaseIcon = this.releaseIcon.split("-");

        this.releaseIcon = `${releaseIcon[0]}-click.svg`;

      }

    },

    mouseUpIcon(module) {

      if (module == "upload") {

        let uploadIcon = this.uploadIcon.split("-");

        this.uploadIcon = `${uploadIcon[0]}-document.svg`;

      } else if (module == "watch") {

        this.watchButton = "watch-unpressed-btn.svg";

      } else {

        let releaseIcon = this.releaseIcon.split("-");

        this.releaseIcon = `${releaseIcon[0]}-hover.svg`;

      }

    },

    UploadIdentificacion: function (evt) {

      this.fileIne = URL.createObjectURL(evt.target.files[0]);

      this.extensionIne = evt.target.files[0].type;

      let aux = this;

      var rdr = new FileReader();

      rdr.onload = function (e) {

        aux.filesIne = e.target.result.split(",")[1];

        //aux.isLoading = true;

        //aux.readIne(aux.filesIne);

      };

      rdr.readAsDataURL(evt.target.files[0]);

    },

    removeCurp(){

      this.fileCurp = null

      this.cleanInputFile('curp-input')

      this.clearCurpInfo()

      this.isValidCurp = undefined

    },

    clearCurpInfo(){

      this.curp = ''

      this.name = ''

      this.lastName = ''

      this.lastName2 = ''

      this.sexo = ''

      this.dia = ''

      this.mes = ''

      this.year = ''

      this.state = ''

    },

    uploadCURP: function (evt) {

      this.fileCurp = URL.createObjectURL(evt.target.files[0]);

      this.extension = evt.target.files[0].type;

      let aux = this;

      var rdr = new FileReader();

      rdr.onload = function (e) {

        aux.isValidCurp = undefined

        aux.isCurpLoading = true

        fetch(

          'https://66jlwm2the.execute-api.us-west-2.amazonaws.com/dev/recognition/curp',

          {

            method: 'POST',

            headers: {

              'Content-Type': 'application/json',

              'x-api-key': 'a9MMrlLbN440PvxpqajL29oL5kQfYfk4tliYOy70'

            },

            body: JSON.stringify({

              pdf_base64: e.target.result.split(",")[1]

            })

          }

        )

        .then((response) => response.json())

        .then((json) => {

            aux.isValidCurp = true

            const [day, month, year] = json.Data.birthdate.split('/')

            aux.curp = json.Data.curp

            aux.name = json.Data.name

            aux.lastName = json.Data.first_surname

            aux.lastName2 = json.Data.second_surname

            aux.sexo = json.Data.sex

            aux.dia = day

            aux.mes = month

            aux.year = year

            aux.state = json.Data.entity

          })

          .catch((err)=>{

            console.log(err);

            aux.isValidCurp = false

            aux.clearCurpInfo()

          })

          .finally(()=>{

            aux.isCurpLoading = false

          })

        aux.filesCurp = e.target.result.split(",")[1];

        //aux.isLoading = true;

        //aux.readCurp(aux.filesCurp);

      };

      rdr.readAsDataURL(evt.target.files[0]);

    },

    readIne(base64) {

      const regexIne = new RegExp(

        "(?:INSTITUTO NACIONAL ELECTORAL|INSTITUTO FEDERAL ELECTORAL)"

      );

      const regexPassaport = new RegExp("(?:PASAPORTE|pasaporte|Pasaporte)");

      const passportNumber = new RegExp("^(G[0-9]{8,9})$");

      const electorNumber = new RegExp("^[A-Z]{6}[0-9]{8}[A-Z]{1}[0-9]{3}$");



      let aux = this;

      var data = { base64: base64 };

      Axios.post(

        "https://e7pj9mzqll.execute-api.us-west-2.amazonaws.com/dev/ApiCurp",

        data,

        {

          "Content-Type": "application/json",

        }

      )

        .then(function (response) {

          var listString = response.data.responses[0].textAnnotations;



          var isIne = listString.filter(function (item) {

            return regexIne.test(item.description);

          });



          var isPass = listString.filter(function (item) {

            return regexPassaport.test(item.description);

          });

          aux.isLoading = false;

          if (isIne.length > 0) {

            aux.ineOK = true;

            aux.documentType = "INE";

            aux.documentValue = listString.filter(function (item) {

              return electorNumber.test(item.description);

            });

            aux.messageIne = "INE: " + aux.documentValue[0].description;

            aux.$notify.success({

              message: "Documento subido es una INE",

              position: "top right",

              timeOut: 5000,

            });

          } else if (isPass.length > 0) {

            aux.ineOK = true;

            aux.documentType = "PASSPORT";

            aux.documentValue = listString.filter(function (item) {

              return passportNumber.test(item.description);

            });

            //console.log(aux.documentValue);

            aux.messageIne = "Pasaporte: " + aux.documentValue[0].description;

            aux.$notify.success({

              message: "EL Documento subido es un PASAPORTE",

              position: "top right",

              timeOut: 5000,

            });

          } else {

            aux.$notify.error({

              message:

                "No es posible detectar una identificación oficial, favor de intentar nuevamente",

              position: "top right",

              timeOut: 15000,

            });

          }

        })

        .catch(function (error) {

          //console.log(error);

          aux.isLoading = false;

          aux.$notify.error({

            message: "Servicio no disponible",

            position: "top right",

            timeOut: 15000,

          });

        });

    },

    readCurp(base64) {

      var data = { base64: base64 };

      if (this.extension == "application/pdf") {

        this.uploadPDF(data);

      } else {

        this.ApiCurpImagen(data);

      }

    },

    ApiCurpImagen(data) {

      const regex = /[A-Z]{1}[AEIOUX]{1}[A-Z]{2}[0-9]{2}(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1])[HM]{1}(AS|BC|BS|CC|CS|CH|CL|CM|DF|DG|GT|GR|HG|JC|MC|MN|MS|NT|NL|OC|PL|QT|QR|SP|SL|SR|TC|TS|TL|VZ|YN|ZS|NE)[B-DF-HJ-NP-TV-Z]{3}[0-9A-Z]{1}[0-9]{1}/;

      // const regexIne = new RegExp("INSTITUTO NACIONAL ELECTORAL");

      // const regexIfe = new RegExp("INSTITUTO FEDERAL ELECTORAL");

      const regexCurp = new RegExp("CONSTANCIA DE LA CLAVE");



      let aux = this;

      Axios.post(

        "https://e7pj9mzqll.execute-api.us-west-2.amazonaws.com/dev/ApiCurp",

        data,

        {

          "Content-Type": "application/json",

        }

      )

        .then(function (response) {

          //var curpP = response.data.curp

          var listString = response.data.responses[0].textAnnotations;

          var curpP = listString.filter(function (item) {

            return regex.test(item.description);

          });

          // var isCurpDoc = listString.filter(function(item) {

          //   return regexCurp.test(item.description);

          // });

          if (curpP.length > 0) {

            aux.curp = curpP[curpP.length - 1].description;

            aux.$notify.success({

              message: "CURP detectada correctamente",

              position: "top right",

              timeOut: 5000,

            });



            //

            aux.validateCURP();

          } else {

            aux.isLoading = false;

            aux.$notify.error({

              message:

                "No es posible leer una CURP del documento subido, favor de intentar nuevamente",

              position: "top right",

              timeOut: 15000,

            });

          }

        })

        .catch(function (error) {

          //console.log(error);

          aux.isLoading = false;

          aux.$notify.error({

            message: "Servicio no disponible",

            position: "top right",

            timeOut: 15000,

          });

        });

    },

    uploadPDF(data) {

      let aux = this;

      Axios.post(

        "https://e7pj9mzqll.execute-api.us-west-2.amazonaws.com/dev/UploadPDF",

        data,

        {

          "Content-Type": "application/json",

        }

      )

        .then(function (response) {

          //var curpP = response.data.curp



          if (response.data.success) {

            var newData = {

              PDFID: response.data.idPDF,

            };



            aux.ApiCurpPDF(newData);

          } else {

            aux.isLoading = false;

          }

        })

        .catch(function (error) {

          aux.isLoading = false;

          aux.$notify.error({

            message: "Servicio no disponible",

            position: "top right",

            timeOut: 15000,

          });

        });

    },

    ApiCurpPDF(data) {

      const regex = /[A-Z]{1}[AEIOUX]{1}[A-Z]{2}[0-9]{2}(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1])[HM]{1}(AS|BC|BS|CC|CS|CH|CL|CM|DF|DG|GT|GR|HG|JC|MC|MN|MS|NT|NL|OC|PL|QT|QR|SP|SL|SR|TC|TS|TL|VZ|YN|ZS|NE)[B-DF-HJ-NP-TV-Z]{3}[0-9A-Z]{1}[0-9]{1}/;

      // const regexIne = new RegExp("INSTITUTO NACIONAL ELECTORAL");

      // const regexIfe = new RegExp("INSTITUTO FEDERAL ELECTORAL");

      // const regexCurp = new RegExp("CONSTANCIA DE LA CLAVE");



      let aux = this;

      Axios.post(

        "https://e7pj9mzqll.execute-api.us-west-2.amazonaws.com/dev/ApiPDF",

        data,

        {

          "Content-Type": "application/json",

        }

      )

        .then(function (response) {

          //var curpP = response.data.curp

          if (response.data.curp) {

            aux.curp = response.data.curp;

            aux.$notify.success({

              message: "CURP detectada correctamente",

              position: "top right",

              timeOut: 5000,

            });

            aux.isLoading = false;

          } else {

            aux.isLoading = false;

            aux.$notify.error({

              message:

                "No es posible leer una CURP del documento subido, favor de intentar nuevamente",

              position: "top right",

              timeOut: 15000,

            });

          }

        })

        .catch(function (error) {

          aux.isLoading = false;



          aux.$notify.error({

            message:

              "Tiempo de carga terminado, favor de intentar nuevamente o intente subir una imagen en formato jpg",

            position: "top right",

            timeOut: 15000,

          });

        });

    },

    cleanCurp() {

      this.curp = "";

      this.fileCurp = "";

    },

    validateFile() {

      var d = new Date();

      var n = d.getFullYear();

      if (n - Number(this.year) >= 18) {

        return true;

      } else {

        return false;

      }

    },

    async validateCURP() {



      try {

        if (this.curp.length == 18) {

          this.isLoading = true;

          let isCorrect = await this.getCurpInfo({

            curp: this.curp.toUpperCase(),

            foto: this.fileAvatar,

          });

          this.isLoading = false;



          if (isCorrect) {

            this.getCandidateInfo();

            var isValid = this.validateFile();

            if (isValid) {

              //this.cleanCurp();

              this.curpOK = true;

              this.step2 = true;

            } else {

              Swal.fire({

                title:

                  "<span style='font-size: 25px; font-weight: 600; margin-top: 1rem;margin-bottom: -1rem; font-family: Josefin Sans; color: #dc7134'>¡ATENCIÓN!</span>",

                html:

                  "<div style='text-align: center; padding-right: 3rem; padding-left: 3rem; font-size: 16px; font-family: Open Sans' color: #828282'>" +

                  "<p>La generación de solicitudes es sólo para mayores de edad.</p>" +

                  "<p style='padding-top: 1rem;'> <img src='/img/icons/InoAlerta.svg' alt='Alerta'/> </p>" +

                  "</div>",

                allowOutsideClick: false,

                width: "50rem",

                padding: "2rem",

                confirmButtonText: "Ok",

                confirmButtonColor: "#dc7134",

                customClass: {

                  confirmButton: "t1-btn t1-btn--primary-block",

                },

                reverseButtons: true,

                onClose: () => { },

              }).then((result) => { });

            }

          } else {

            this.$notify.error({

              message: "CURP incorrecta, favor de verificar",

              position: "top right",

              timeOut: 5000,

            });

            //this.cleanCurp();

          }

        }



      } catch (error) {

        this.isLoading = false;

        //console.log(error.response)

        if (error.response.status == 409) {

          Swal.fire({

            title:

              "<span style='font-size: 25px; font-weight: 600; margin-top: 1rem;margin-bottom: -1rem; font-family: Josefin Sans; color: #dc7134'>¡ATENCIÓN!</span>",

            html:

              "<div style='text-align: center; padding-right: 3rem; padding-left: 3rem; font-size: 16px; font-family: Open Sans' color: #828282'>" +

              "<p>La CURP proporcionada ya ha sido registrada en una solicitud de admisión anterior. Por lo tanto, un solicitante que haya presentado una solicitud previa no puede volver a realizarla.</p>" +

              "<p style='padding-top: 1rem;'> <img src='/img/icons/InoAlerta.svg' alt='Alerta'/> </p>" +

              "</div>",

            allowOutsideClick: false,

            width: "50rem",

            padding: "2rem",

            confirmButtonText: "Ok",

            confirmButtonColor: "#dc7134",

            customClass: {

              confirmButton: "t1-btn t1-btn--primary-block",

            },

            reverseButtons: true,

            onClose: () => { },

          }).then((result) => { });

        }

        else {

          this.$notify.error({

            message: "El servicio de lectura de CURP no esta disponible, favor de ingresar sus datos manualmente",

            position: "top right",

            timeOut: 15000,

          });

          this.disabledCurp = false;



        }



      }



    },

    uploadActa: function (evt) {

      this.actaUrl = URL.createObjectURL(evt.target.files[0]);

      let aux = this;

      var rdr = new FileReader();

      rdr.onload = function (e) {

        aux.actaPDF = e.target.result.split(",")[1];

      };

      rdr.readAsDataURL(evt.target.files[0]);

    },

    uploadFile: function (evt) {

      this.fileAvatar = URL.createObjectURL(evt.target.files[0]);

      let aux = this;

      var rdr = new FileReader();

      rdr.onload = function (e) {

        aux.filesProfile = e.target.result.split(",")[1];

      };

      rdr.readAsDataURL(evt.target.files[0]);

    },

    ...mapActions(["logOut"]),

    async logout() {

      await this.logOut();

      this.$router.push("/");

    },

    confirmCurp() {

      //datos del conyuge

      if (this.maritalStatus == "MARRIED") {

        this.createDataConyuge();

      } else {

        this.create();

      }

    },

    showApplicationNumber() { },

    getCandidateInfo() {

      //this.candidate = this.$store.state.candidate.candidateInfo

      this.name = this.candidate.name;

      this.lastName = this.candidate.lastName;

      this.lastName2 = this.candidate.lastName2;

      this.sexo = this.candidate.sexo;

      this.state = this.candidate.state;

      this.dia = this.candidate.dia;

      this.mes = this.candidate.mes;

      this.year = this.candidate.year;

      this.urlAvatar = this.candidate.urlAvatar;

      this.curp = this.candidate.curp;

    },

    async createDataConyuge() {

      if (this.name != "") {

        if (this.dia <= 9) {

          if (this.dia.length == undefined || this.dia.length < 2)

            this.dia = "0" + this.dia;

        }

        if (this.mes <= 9) {

          if (this.mes.length == undefined || this.mes.length < 2)

            this.mes = "0" + this.mes;

        }

        try {

          this.isLoading = true;

          let laborData = {}



          if (this.work) {

            laborData.working = this.work

            laborData.company = this.nameCompany

            laborData.phone = this.phoneCompany,

              laborData.position = this.currentPosition

            laborData.profession = this.profession

            laborData.businessActivity = this.businessActivity

            laborData.addressCompany = this.addressCompany

          }

          else {

            laborData.working = this.work

            laborData.activityDescription = this.activityDescription

          }

          let body = {

            beneficiaryType: "SPOUSE",

            lastName: this.lastName.toUpperCase(),

            motherLastName: this.lastName2.toUpperCase(),

            name: this.name.toUpperCase(),

            birthDate: this.dia + "-" + this.mes + "-" + this.year,

            birthPlace: this.state,

            laborDataDTO: laborData,

            documentsDTO: [

              {

                documentType: "CURP",

                value: this.curp,

                extension: "pdf",

                mimeType: "application/pdf",

                content: this.filesCurp,

              },

              {

                documentType: "INE",

                value: "",

                extension: "pdf",

                mimeType: "application/pdf",

                content: this.filesIne,

              },

              {

                documentType: "PROFILE_PICTURE",

                value: "",

                extension: "jpeg",

                mimeType: "image/jpeg",

                content: this.fileAvatar.split(",")[1],

              },

              {

                documentType: "BIRTH_CERTIFICATE",

                value: "",

                extension: "pdf",

                mimeType: "application/pdf",

                content: this.actaPDF,

              },

            ],

          };





          if (this.pdfUrl != null) {

            body.documentsDTO.push({

              documentType: "TAX_STATUS_LETTER",

              value: "",

              extension: "pdf",

              mimeType: "application/pdf",

              content: this.filesPDF,

            })

          }



          let response = await this.postDataSpouse(body);



          if (response.data.status == 200 || response.data.status == 201) {

            let data = {};

            data.considerApplicant = true;

            data.considerSpouse = true;

            await this.sendInvestigation(data);

            this.isLoading = false;



            // this.$notify.success({

            //   message: response.data.message,

            //   position: "top right",

            //   timeOut: 5000

            // });



            Swal.fire({

              title:

                "<span style='font-size: 25px; font-weight: 600; margin-top: 1rem;margin-bottom: -1rem; font-family: Josefin Sans; color: #828282'>¡ENVÍO DE DATOS EXITOSO!</span>",

              html:

                "<div style='text-align: center; padding-right: 3rem; padding-left: 3rem; font-size: 16px; font-family: Open Sans' color: #828282'>" +

                "<p>Los datos han sido enviados correctamente. Espera indicaciones del Club para continuar con el proceso, revisa tu correo constantemente.</p>" +

                // "<p style='font-weight: 600;'>Recibirás respuesta de tu solicitud en un plazo aproximado de tres semanas</p>" +

                "<p style='padding-top: 1rem;'> <img src='/img/icons/sent-code.svg' alt='sendEmail'/> </p>" +

                "</div>",

              allowOutsideClick: false,

              width: "50rem",

              padding: "2rem",

              confirmButtonText: "Ok",

              confirmButtonColor: "#dc7134",

              customClass: {

                confirmButton: "t1-btn t1-btn--primary-block",

              },

              onClose: () => { },

            }).then((result) => {

              this.$router.push("/home");

            });

          } else {

            this.isLoading = false;

            this.$notify.error({

              message: response.data.errorDetails,

              position: "top right",

              timeOut: 15000,

            });

          }

        } catch (e) {

          this.isLoading = false;

          //console.log(e);

          if (e.response.status == 401) {

            this.logout();

          }



          if (e.response.status == 409) {

            Swal.fire({

              title:

                "<span style='font-size: 25px; font-weight: 600; margin-top: 1rem;margin-bottom: -1rem; font-family: Josefin Sans; color: #dc7134'>¡ATENCIÓN!</span>",

              html:

                "<div style='text-align: center; padding-right: 3rem; padding-left: 3rem; font-size: 16px; font-family: Open Sans' color: #828282'>" +

                "<p>La CURP proporcionada ya ha sido registrada en una solicitud de admisión anterior. Por lo tanto, un solicitante que haya presentado una solicitud previa no puede volver a realizarla.</p>" +

                "<p style='padding-top: 1rem;'> <img src='/img/icons/InoAlerta.svg' alt='Alerta'/> </p>" +

                "</div>",

              allowOutsideClick: false,

              width: "50rem",

              padding: "2rem",

              confirmButtonText: "Ok",

              confirmButtonColor: "#dc7134",

              customClass: {

                confirmButton: "t1-btn t1-btn--primary-block",

              },

              reverseButtons: true,

              onClose: () => { },

            }).then((result) => { });

          } else {

            this.$notify.error({

              message: "Ups ha ocurrido un error desconocido",

              position: "top right",

              timeOut: 15000,

            });

            this.$notify.error({

              message: e.response.data.errorDetails,

              position: "top right",

              timeOut: 15000,

            });

          }

        }

      }

    },



    async create() {

      if (this.dia <= 9) {

        if (this.dia.length == undefined || this.dia.length < 2)

          this.dia = "0" + this.dia;

      }

      if (this.mes <= 9) {

        if (this.mes.length == undefined || this.mes.length < 2)

          this.mes = "0" + this.mes;

      }

      try {

        this.isLoading = true;



        let RecomendationsDTO = [];

        for (let i in this.recomendations) {



          let jsonRecomendations = {

            partnerName: this.recomendations[i].firstName,

            partnerLastName: this.recomendations[i].lastName,

            partnerMothersLastName: this.recomendations[i].motherLastName,

            deedNumber: this.recomendations[i].accion,

            email: this.recomendations[i].email,

            cellPhone: this.recomendations[i].phone,

          }

          RecomendationsDTO.push(jsonRecomendations)

        }



        let laborData = {}



        if (this.work) {

          laborData.working = this.work

          laborData.company = this.nameCompany

          laborData.phone = this.phoneCompany,

            laborData.position = this.currentPosition

          laborData.profession = this.profession

          laborData.businessActivity = this.businessActivity

          laborData.addressCompany = this.addressCompany

        }

        else {

          laborData.working = this.work

          laborData.activityDescription = this.activityDescription

        }



        let phones = []



        let singlePhone = {

          phone: this.phoneApplicant,

          phoneType: "Personal",

          contactName: "",

          contactRelationship: ""

        }

        phones.push(singlePhone)



        let body = {

          lastName: this.lastName.toUpperCase(),

          motherLastName: this.lastName2.toUpperCase(),

          name: this.name.toUpperCase(),

          birthDate: this.dia + "-" + this.mes + "-" + this.year,

          birthPlace: this.state,

          maritalStatus: this.estadoCivil,

          laborDataDTO: laborData,

          recommendationsDTO: RecomendationsDTO,

          phones: phones,

          documentsDTO: [

            {

              documentType: "CURP",

              value: this.curp,

              extension: "pdf",

              mimeType: "application/pdf",

              content: this.filesCurp,

            },

            {

              documentType: "INE",

              value: "",

              extension: "pdf",

              mimeType: "application/pdf",

              content: this.filesIne,

            },

            {

              documentType: "PROFILE_PICTURE",

              value: "",

              extension: "jpeg",

              mimeType: "image/jpeg",

              content: this.fileAvatar.split(",")[1],

            },

            {

              documentType: "BIRTH_CERTIFICATE",

              value: "",

              extension: "pdf",

              mimeType: "application/pdf",

              content: this.actaPDF,

            },

          ],

        };



        if (this.pdfUrl != null) {

          body.documentsDTO.push({

            documentType: "TAX_STATUS_LETTER",

            value: "",

            extension: "pdf",

            mimeType: "application/pdf",

            content: this.filesPDF,

          })

        }



        if (this.estadoCivil == "DIVORCED") {

          body.exSpouseFullName = this.exCoupleName;

        }



        //console.log(body);

        let response = await this.completeStep1(body);



        this.isLoading = false;

        if (response.data.status == 200 || response.data.status == 201) {

          this.$notify.success({

            message: response.data.message,

            position: "top right",

            timeOut: 5000,

          });

          //GUARDAR LA RESPUESTA EN LOCAL STORAGE y en vuex

          this.$store.commit("setApplicationId", response.data.data);

          this.$store.commit("setMaritalState", this.estadoCivil);



          localStorage.setItem("application_id", response.data.data);



          Swal.fire({

            title:

              "<span style='font-size: 20px; font-family: Josefin Sans; color: #828282'>¡GENERACIÓN DE SOLICITUD EXITOSA!</span>",

            html:

              "<div style='text-align: initial; padding-left: 7rem; padding-top: 1rem; font-size: 13px; font-family: Open Sans' color: #828282'>" +

              "<p>Solicitud generada a nombre de: <span style='padding: 5px; background-color: #3a8a65; color: #fff; font-weight: 600;'>" +

              this.name.toUpperCase() +

              " " +

              this.lastName.toUpperCase() +

              " " +

              this.lastName2.toUpperCase() +

              "</span> </p>" +

              "<p style='padding-top: 1rem;'>Con número de solicitud: <span style='padding: 5px; background-color: #3a8a65; color: #fff; font-weight: 600;'>" +

              response.data.data +

              "</span></p>" +

              "</div>",

            allowOutsideClick: false,

            width: 600,

            padding: "4em",

            confirmButtonColor: "#dc7134",

            confirmButtonText: "Ok",

            onClose: () => { },

          }).then((result) => {

            if (result.value) {

              //window.location.href="../home"

              this.$router.replace("/home");

            }

          });

        } else {

          this.$notify.error({

            message: response.data.errorDetails,

            position: "top right",

            timeOut: 15000,

          });

        }

      } catch (e) {

        this.isLoading = false;

        //console.log(e);

        if (e.response.status == 401) {

          this.logout();

        }



        if (e.response.status == 409) {

          Swal.fire({

            title:

              "<span style='font-size: 25px; font-weight: 600; margin-top: 1rem;margin-bottom: -1rem; font-family: Josefin Sans; color: #dc7134'>¡ATENCIÓN!</span>",

            html:

              "<div style='text-align: center; padding-right: 3rem; padding-left: 3rem; font-size: 16px; font-family: Open Sans' color: #828282'>" +

              "<p>La CURP proporcionada ya ha sido registrada en una solicitud de admisión anterior. Por lo tanto, un solicitante que haya presentado una solicitud previa no puede volver a realizarla.</p>" +

              "<p style='padding-top: 1rem;'> <img src='/img/icons/InoAlerta.svg' alt='Alerta'/> </p>" +

              "</div>",

            allowOutsideClick: false,

            width: "50rem",

            padding: "2rem",

            confirmButtonText: "Ok",

            confirmButtonColor: "#dc7134",

            customClass: {

              confirmButton: "t1-btn t1-btn--primary-block",

            },

            reverseButtons: true,

            onClose: () => { },

          }).then((result) => { });

        } else {

          this.$notify.error({

            message: "Ups ha ocurrido un error desconocido",

            position: "top right",

            timeOut: 15000,

          });

          this.$notify.error({

            message: e.response.data.errorDetails,

            position: "top right",

            timeOut: 15000,

          });

        }

      }

    },

    onCapture() {

      this.imgSrc = this.$refs.webcam.capture();

      this.$refs.cropper.replace(this.imgSrc);

      //this.$refs.camera.toggleModal();

      //this.$refs.webcam.stop();

      //this.fileAvatar = this.imgSrc;

    },

    onStarted(stream) {

      //console.log("On Started Event", stream);

    },

    onStopped(stream) {

      //console.log("On Stopped Event", stream);

    },

    onStop() {

      this.$refs.webcam.stop();

    },

    onStart() {

      this.$refs.webcam.start();

    },

    onError(error) {

      //console.log("On Error Event", error);

    },

    onCameras(cameras) {

      this.devices = cameras;

      //console.log("On Cameras Event", cameras);

    },

    onCameraChange(deviceId) {

      this.deviceId = deviceId;

      this.camera = deviceId;

      //console.log("On Camera Change Event", deviceId);

    },

    closeMessageError() {

      Swal.fire({

        title:

          "<span style='font-size: 25px; font-weight: 600; margin-top: 1rem;margin-bottom: -1rem; font-family: Josefin Sans; color: #dc7134'>¡ATENCIÓN!</span>",

        html:

          "<div style='text-align: center; padding-right: 3rem; padding-left: 3rem; font-size: 16px; font-family: Open Sans' color: #828282'>" +

          "<p>¿Estás seguro de cerrar la ventana para crear tu solicitud? Si haces esto la solicitud no será generada.</p>" +

          "<p style='padding-top: 1rem;'> <img src='/img/icons/InoAlerta.svg' alt='Alerta'/> </p>" +

          "</div>",

        allowOutsideClick: false,

        showCancelButton: true,

        width: "50rem",

        padding: "2rem",

        cancelButtonText: "Cancelar",

        confirmButtonText: "Aceptar",

        confirmButtonColor: "#dc7134",

        customClass: {

          cancelButton: "t1-btn t1-btn--ghost",

          confirmButton: "t1-btn t1-btn--primary-block",

        },

        reverseButtons: true,

        onClose: () => { },

      }).then((result) => {

        if (result.value) {

          this.$router.push("/home");

        }

      });

    },

    async setFilterDay() {

      try {

        if (this.$refs.filterDay.open) {

          this.$refs.filterDay.toggleModal();

        }

        //console.log(this.datePickerValue)

        const date = moment(this.datePickerValue).format('DD-MM-YYYY');



        //console.log(date)

        this.dia = date.split("-")[0]

        this.mes = date.split("-")[1]

        this.year = date.split("-")[2]





      }

      catch (e) {

        this.pushNotifyError();

      }

    },

  },

  mounted() {

    //this.$refs.webcam.stop();

  },

  created() {

    this.recommendatiosN();

  },

  computed: {

    ...mapGetters({

      candidate: "getCandidate",

      maritalStatus: "getMaritalStatus",

    }),

    treeImg() {

      if (this.maritalStatus == "MARRIED") {

        return "/img/tree/Wizard2-Conyuge-01.svg";

      } else {

        return "/img/tree/Wizard2-Soltero-01.svg";

      }

    },

    device: function () {

      return this.devices.find((n) => n.deviceId === this.deviceId);

    },

    displayedPost() {

      return this.recomendations;

    },

  },

  watch: {



    fileAvatar(value) {

      if (value != "") {

        this.imageError = false;

      }

    },

    fileCurp(value) {

      if (value != "") {

        this.CURPimageError = false;

      }

    },

    fileIne(value) {

      if (value != "") {

        this.IneImageError = false;

      }

    },



    isCorrect(newValue) {

      this.isInCorrect = !newValue;

    },

    isInCorrect(newValue) {

      this.isCorrect = !newValue;

    },

    camera: function (id) {

      this.deviceId = id;

    },

    devices: function () {

      // Once we have a list select the first one

      const [first,] = this.devices;

      if (first) {

        this.camera = first.deviceId;

        this.deviceId = first.deviceId;

      }

    },

    year(value) {

      if (value.length == 4) {

        var isValid = this.validateFile();



        if (isValid) {

          this.curpOK = true;

        } else {

          this.isValidCurp = undefined

          this.clearCurpInfo()

          Swal.fire({

            title:

              "<span style='font-size: 25px; font-weight: 600; margin-top: 1rem;margin-bottom: -1rem; font-family: Josefin Sans; color: #dc7134'>¡ATENCIÓN!</span>",

            html:

              "<div style='text-align: center; padding-right: 3rem; padding-left: 3rem; font-size: 16px; font-family: Open Sans' color: #828282'>" +

              "<p>La generación de solicitudes es sólo para mayores de edad.</p>" +

              "<p style='padding-top: 1rem;'> <img src='/img/icons/InoAlerta.svg' alt='Alerta'/> </p>" +

              "</div>",

            allowOutsideClick: false,

            width: "50rem",

            padding: "2rem",

            confirmButtonText: "Ok",

            confirmButtonColor: "#dc7134",

            customClass: {

              confirmButton: "t1-btn t1-btn--primary-block",

            },

            reverseButtons: true,

            onClose: () => { },

          })

        }



      }

    },

  },

};

</script>





<style scoped>

.disabled_color{

  background-color: #e9ecef;

}

.custom-select {

  font-size: 1.8rem;

  padding: .6rem 1rem;

  border-radius: .8rem;

  border: 0.15rem solid #bdbdbd;

  width: 100%;

  display: block;

  color: #828282;

  -webkit-transition: all .2s;

  transition: all .2s;

  height: 42px;

}



.input-group-prepend>input::placeholder {

  font-size: 14px;

}



.uploadIcon {

  cursor: pointer;

  background-color: rgb(220, 113, 52);

  padding: 9.4px;

  border-radius: 0px 4px 4px 0px;

  /* margin-top: 12px;

    margin-left: 20px; */

}



.approvedIcon {

  width: 5rem;

}



.class-container {

  background: #fff !important;

  height: 100%;

  width: 100%;

  padding-top: 1rem;

  padding-bottom: 9vh;

}



.center {

  margin: auto;

  margin-top: 120px;

  width: 60%;



  padding-bottom: 20%;

}



.text-style {

  font-size: 27px;

  color: #285f46;

  font-weight: 600;

  text-transform: uppercase;

}



.text-style-2 {

  font-size: 20px;

  color: #285f46;

  font-weight: normal;

}



.Rectangle-78 {

  width: 1px;

  height: 100%;

  border: 1px solid #285f46;

}



.Rectangle-366 {

  width: 882px;

  height: 205px;

  border-radius: 5px;

  border: solid 1px #3a8a65;

}



.btn-crear {

  width: 10rem;

  height: 3rem;

  border-radius: 3.5px;

  background-color: #dc7134;

  color: #ffffff;

  font-size: 12px;

}



.btn-cancelar {

  width: 11.5rem;

  height: 3rem;

  border: 1px solid #bdbdbd;

  border-radius: 3.5px;

  background-color: #ffffff;

  color: #bdbdbd;

  font-size: 12px;

}



.curp-upload>input {

  display: none;

}



.image-upload>input {

  display: none;

}



.btn-label {

  border-radius: 5px;

  background-color: #dc7134;

  padding: 0.4rem 2.5rem;

  font-size: 12px;

  font-weight: normal;

  font-stretch: normal;

  font-style: normal;

  line-height: normal;

  letter-spacing: normal;

  color: #ffffff;

  font-weight: 600;

  font-family: Josefin Sans;

  cursor: pointer;

}



.btn-edit {

  padding: 6px;

  background-color: #c4c4c4 !important;

  border-radius: 3px;

  box-shadow: unset;

}



.btn-edit:hover {

  background-color: #f78c4f !important;

}



.btn-edit:active {

  background-color: #dc7134 !important;

}



.btn-delete {

  padding: 6px;

  background-color: #c4c4c4 !important;

  border-radius: 3px;

  box-shadow: unset;

}



.btn-delete:hover {

  background-color: #eb5757 !important;

}



.btn-delete:active {

  background-color: #d65050 !important;

}



.divLine {

  width: 100%;

  border: 0.1rem solid #828282;

}



.edit-pic {

  cursor: pointer;

  position: absolute;

  z-index: 100;

}



.avatar-pic {

  /* position: absolute; */

  /* border: 0.6rem solid #285f46; */

  border-radius: 50%;

  width: 13rem;

  height: 13rem;

}



.help-curp {

  width: 29rem;

  position: absolute;

  bottom: 0rem;

  z-index: 10000;

}



.split {

  border: 0.15rem solid #bdbdbd;

  font-size: 1.5rem;

  padding: 0.6rem 1rem;

  border-radius: 0.8rem;

  width: 30%;

  color: #828282;

  transition: all 0.2s;

  text-align: center;

}



.form-check-input[type="checkbox"]:checked+label:before,

label.btn input[type="checkbox"]:checked+label:before {

  top: -4px;

  /* left: -5px; */

  width: 11px;

  height: 18px;

  border-top: 2px solid transparent;

  border-right: 2px solid #f78c4f;

  border-bottom: 2px solid #f78c4f;

  border-left: 2px solid transparent;

  -webkit-transform: rotate(40deg);

  transform: rotate(40deg);

  -webkit-transform-origin: 100% 100%;

  transform-origin: 100% 100%;

  -webkit-backface-visibility: hidden;

  backface-visibility: hidden;

}



.form-check-input[type="checkbox"]+label:before,

.form-check-input[type="checkbox"]:not(.filled-in)+label:after,

label.btn input[type="checkbox"]+label:before,

label.btn input[type="checkbox"]:not(.filled-in)+label:after {

  position: absolute;

  top: 0;

  left: 0;

  z-index: 0;

  width: 18px;

  height: 18px;

  margin-top: 3px;

  content: "";

  border: 2px solid #8a8a8a;

  border-radius: 1px;

  -webkit-transition: 0.2s;

  transition: 0.2s;

}



@media (max-width: 80.2rem) {}



@media (min-height: 850px) {

  .class-container {

    padding-bottom: 40vh;

  }



  /* .uploadIcon{

    margin-top: 3px;



} */

}



.table td {

  font-size: 12px;

  font-family: Open Sans;

  text-transform: uppercase;

}



.btn-acta-nacimiento {

  display: inline-block;

  margin-left: 10px;

}



.main-col {

  margin: auto;

  width: 60%

}



.datepicker {

  border-color: red;

}



/*responsive*/



@media (max-width: 50rem) {



  .cardClass {

    padding-bottom: 10rem;

  }



  .Rectangle-78 {

    display: none;

  }



  .main-col {

    width: 100%;

  }

}

</style>